// ============================================================================
// BINOMIAL HEAP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'binomial-heap',
  name: 'Binomial Heap',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A heap data structure similar to binary heap but supports efficient merge operation in O(log N) time. Implemented as a collection of binomial trees, each satisfying the heap property.'
};
